import React from 'react'
import { useState } from 'react';
import Header from '../components/Header'
import Footer from '../components/Footer'
import "../components/styles/ContactUs.css"


import { toast, ToastContainer } from "react-toastify";
import BookPanditForm from "../components/BookPanditForm";
const ContactUs = () => {
    const [isMobile, setIsMobile] = useState(false);
  return (
    <>
      <Header />
      <div className='Contact'>
        <div className="container">
          <div className="row d-flex justify-content-center gap-3 ">
            <div className="col-md-4 col-12 contact_card">
              <i class="fa-solid fa-location-dot"></i>
              <h2>Lorem ipsum dolor sit amet, consectetur adipiscing elit, </h2>
            </div>
            <div className="col-md-4 col-12 contact_card">
              <i class="fa-solid fa-envelope"></i>
              <h2>contact@ezpujapath.com</h2>
            </div>
            <div className="col-md-4 col-12 contact_card">
              <i class="fa-solid fa-phone"></i>
              <h2>+91- 9031296761
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className=" contact_container_part2 " style={{ backgroundColor: "#6B2A00" }}>
        <div className="container">
          <div className="row   ">
            <div className="col-lg-6 col-12  align-content-center " style={{ color: "white" }}>
              <h1>Get In Touch</h1>
              <p className='mt-5'>Discover the deeper aspects of your life with a personalized astrological analysis. Understand your personality, strengths, challenges, and life path through the placement of signs and planets in your birth chart.</p>
              <p className='mt-4'>🔹 Career & Education Guidance – Choose the right path for <br/> success and fulfillment</p>
              <p className='mt-4'>🔹 Career & Education Guidance – Choose the right path for <br/> success and fulfillment</p>
              <p className='mt-4'>🔹 Career & Education Guidance – Choose the right path for <br/> success and fulfillment</p>
              <p className='mt-4'>🌟 Don’t leave your future to chance! Connect with us today <br/> and gain clarity, confidence, and cosmic guidance.</p>
            </div>


            <div className={isMobile ? "bg-white" : "Container_img img-fluid"}>
    
    
            <BookPanditForm />
            <ToastContainer />
    
            </div>
  
          </div>
        </div>
      </div>
      <Footer />
    </>

  )
}

export default ContactUs